import { create } from 'zustand';

export default create((set) => ({
  isOfficeUser: false,
  setIsOfficeUser: (isOfficeUser) => set({ isOfficeUser }),
}));
